var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25309 2.05204C4.32247 -0.0173459 7.67761 -0.0173463 9.74699 2.05204C11.8164 4.12142 11.8164 7.47656 9.74699 9.54594L6.00004 13.2929L2.25309 9.54594C0.183704 7.47656 0.183704 4.12142 2.25309 2.05204ZM6.00004 7.95584C7.19124 7.95584 8.1569 6.99019 8.1569 5.79899C8.1569 4.60779 7.19124 3.64214 6.00004 3.64214C4.80884 3.64214 3.84319 4.60779 3.84319 5.79899C3.84319 6.99019 4.80884 7.95584 6.00004 7.95584Z",
    stroke: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.dbcda7d429b9d555fda48b426de3b452.svg";
export { ForwardRef as ReactComponent };